import cookie from 'js-cookie'
export default {
  user: null,//cookie.get('user') ? JSON.parse(cookie.get('user')) : null,
  locale: 'nl'
}
